import * as ActionCasesFns from './utilities/ActionCasesFns';
import * as CoreFns from './utilities/CoreFns';
import * as StandardFns from './utilities/StandardFns';
import * as ResponsiveFns from './utilities/ResponsiveFns';

export function getInputTypeFromInput(potentialInputItem1){
  var potentialInputItem = potentialInputItem1.s;
  if (potentialInputItem.inputType){
    var inp = potentialInputItem.inputType.v;
    if (inp === 'Text String' || inp === 'Integer' || inp === 'UInteger' || inp === 'Decimal' || inp === 'Date' || inp === 'Date Time'){
      return {t:inp};
    }else if (inp === 'Radio'){
      if (potentialInputItem.allowMultiple){
        return {t:'ListType', c:{t:'Text String'}};
      }else{  
        return {t:'Text String'};
      }
    }else if (inp === 'Long Text' || inp === 'Single Select'){
      return {t:'Text String'};
    // }else if (inp === 'Multiple Select'){
    //   return {t:'ListType', c:[{t:'Text String'}]};
    }
  }
  return {t:'toDelete', msg:'Input type not defined'};  
}

export function getOutputFromESOutputs(thisAbi, name){
    if (thisAbi.outputs.length === 1){
      return thisAbi.outputs[0];
    }else if (name === 0 || name > 0){
      return thisAbi.outputs[name];
    }else{
      for (var i = 0; i < thisAbi.outputs.length; i++){
        if (thisAbi.outputs[i].name === name){
          return thisAbi.outputs[i];
        }
      }
    }

}
export function getESType(firstNode, currentList){
  var thisAbi = ResponsiveFns.getToRelevantAbi(firstNode, currentList);
  if (thisAbi){
    var thisOutput = getOutputFromESOutputs(thisAbi, firstNode.n);
    var thisType;
    try{
      thisType = convertSCTypeToInternalType(thisOutput);
    }catch(err){
      console.log(firstNode);
      console.log(thisOutput);
      console.log(thisAbi);      
    }
    var finalType = walkDownObjPathToGetType(thisType, firstNode.p);
    return finalType;
  }

  var relevantFn = firstNode.i.split(' ')[0];
  var contractInfo = CoreFns.getContractInfo(currentList, firstNode.s);
  if (contractInfo){
    return {t:'toDelete', msg:'The ' + relevantFn + ' does not exist on the ' + contractInfo.contractName + ' contract.'};
  }else{
    return {t:'toDelete', msg:'Contract has been deleted'};
  }

}

export function convertSCTypeToInternalType(abiLine){

  function typeIteration(type, components){
    if (type.indexOf('[') > -1){
      var prior = type.substr(0, type.indexOf('['));
      var c = typeIteration(prior, components);
      return {t:'ListType', c};
    }else if (type.indexOf('uint') === 0){
      return {t:'UInteger'};
    }else if (type.indexOf('int') === 0){
      return {t:'Integer'};
    }else if (type === 'bool'){
      return {t:'Boolean'};
    }else if (type === 'string'){
      return {t:'Text String'};
    }else if (type === 'address'){
      return {t:'Address'};
    }else if (type.indexOf('bytes') === 0){
      return {t:'any'};
    }else if (type === 'tuple'){
      var c1 = components.map((aComponent, index)=>{
        var t = convertSCTypeToInternalType(aComponent);
        var key = aComponent.name;
        return {t, key, n:aComponent.name};
      })
      return {t:'Object', c:c1};
    }else{
      console.log(type);
      return {t:'toDelete', msg:'Unknown Smart Contract Type'};
    }
  }

  return typeIteration(abiLine.type, abiLine.components);
}


export function getInputTypeFromKey(currentList, path){
  try{
    var item = CoreFns.goDownPath(currentList, path);
    if (item){
      return getInputTypeFromInput(item);
    }
  }catch(err){
  }
  return {t:'toDelete', msg:'Input removed'}
}

export function getInputType(currentList, p1){
  var goTo = [];
  for (var i = 0; i < p1.length; i++){
    if (p1[i] === 'oc'){
      break;
    }else{
      goTo.push(p1[i]);
    }
  }
  var potentialInputItem1 = CoreFns.goDownPath(currentList, goTo, 0);
  return getInputTypeFromInput(potentialInputItem1);
}



export function evalType(condition, entityPath, currentList, upwardInfo){

  var ct = condition.t;
  
  if (ct === 'eS'){ 
    return getESType(condition, currentList);
  }else if (ct === 'aC'){
    var actionCases = ActionCasesFns.getActionCasesFn(entityPath);
    return ActionCasesFns.getType(actionCases, condition);
  }else if (ct === 'f'){
    var i = condition.i;
    if (i === 1 || i === 2 || i === 3 || i === 4 || i === 5 || i === 6 || i === 7 || i === 24 || i === 59 || i === 77 ){
      return evalType(condition.v[0], entityPath, currentList, upwardInfo);
    }else if (i === 99 || i === 100 || i === 101 || i === 102 || i === 93){
      var c = evalType(condition.v[0], entityPath, currentList, upwardInfo);
      if (c.t === 'ListType'){
        return c.c;
      }else{
        return {t:'toDelete'};
      }
    }else if (i === 71 || i === 13 || i === 52){
      return evalType(condition.v[1], entityPath, currentList, upwardInfo);
    }else if (i === 58){
      var c0 = evalType(condition.v[0], entityPath, currentList, upwardInfo);
      var c2 = evalType(condition.v[1], entityPath, currentList, upwardInfo.concat([{t:condition.m0,type:c0.c}]));
      return {t:'ListType',c:c2};
    }else if (i === 60){
      if (condition.v.length === 0){
        return {t:'ListType', c:{t:'any'}};
      }else{
        return {t:'ListType',c:evalType(condition.v[0], entityPath, currentList, upwardInfo)};
      }
    }else if (i === 61){
      var c5 = condition.v.map((aCond, index)=>{
        var c1 = evalType(aCond, entityPath, currentList, upwardInfo);
        return {t:c1, n:aCond.ti};
      })
      return {t:'Object',c:c5}
    }else if (i === 108){
      if (currentList && currentList._g && currentList._g.curr && currentList._g.curr.o){
        return {t:'Text String'};
      }else{
        return {t:'toDelete', msg:'Need to select a blockchain'};
      }
    }else{
      return StandardFns.functionalPieces[i].out;
    }
  }else if (ct === 'gV'){ 
    return typeOfAGoverningFormula(condition, currentList, upwardInfo);
  }else if (ct === 'm'){
    for (var i15 = 0; i15 < upwardInfo.length; i15++){
      if (upwardInfo[i15].t === condition.v){
        return walkDownObjPathToGetType(upwardInfo[i15].type, condition.p);
      }
    }
    throw new Error("huh");
  }else if (ct === 'inP'){
    return getInputTypeFromKey(currentList, condition.v);
  }else{
    return simpEvalType(condition, currentList, entityPath);
  }

}

export function simpEvalType(condition, currentList, entityPath){
  var ct = condition.t;
  if (ct === 's'){ return {t:"Text String"};
  }else if (ct === 'scr'){ return {t:'Screen'};
  }else if (ct === 'mus'){ return {t:'Music'};
  }else if (ct === 'i' || ct === 'gi'){ return {t:'Integer'}
  }else if (ct === 'coin'){ return {t:'Coin'};
  }else if (ct === 'curr'){ return {t:'Currency'};
  }else if (ct === 'eV'){ return {t:'ScEvent'};
  }else if (ct === 'ui'){ return {t:'UInteger'}
  }else if (ct === 'dt'){ return {t:'UInteger', sp:'dateTime'}
  }else if (ct === 'dc'){ return {t:'Decimal'}
  }else if (ct === 'ad'){ return {t:'Address'}
  }else if (ct === 'ca'){ 
    if (currentList.sc[condition.v]){
      return {t:'Address'}
    }else{
      return {t:'toDelete', msg:'Contract deleted'};
    }
  }else if (ct === 'tx'){ return {t:'Transaction'}
  }else if (ct === 'pu'){ return {t:'PopUp'}
  }else if (ct === 'oVar'){
    var thisOC = currentList.ov[condition.v];
    if (thisOC){
      if (entityPath[0] === 'ov'){
        var ov = currentList.ov;
       var ovKeys = CoreFns.sortedKeyList(ov);
        var haveFound5 = false;
        for (var i6 = 0; i6 < ovKeys.length; i6++){
          var anOVKey = ovKeys[i6];
          if (anOVKey === entityPath[1]){
            break;
          }else if (anOVKey === condition.v){
            haveFound5 = true;
          }
        }
        if (!haveFound5){
          var name = CoreFns.goDownPath(currentList, ['ov', entityPath[1], 'n']);
          return {t:'toDelete', msg:'The variable ' + thisOC.n + ' is defined after ' + name + ' and hence cannot be used'};
        }
      }
      return walkDownObjPathToGetType(CoreFns.convertSelectionToType(thisOC.t, currentList), condition.p);
    }else{
      return {t:'toDelete', msg:'Variable has been deleted'};
    }
  }else if (ct === 'gi'){
    return {t:'Integer'};
  }else if (ct === 'pa' || ct === 'footer'){
    return {t:'Panel'};
  }else if (ct === 'pl'){
    return {t:condition.ti};
  }else if (ct === 'al'){
    return {t:'Alert'};
  }else{
    console.warn(condition)
  }

}

export function typeOfAGoverningFormula(aPrior, currentList, upwardInfo){

  var thisItem = CoreFns.goDownPath(currentList, aPrior.v, 0);
  var rFormula = thisItem.s.rFormula;
  if (rFormula.t === 'formula'){
    var type = evalType(rFormula.o, aPrior.v, currentList, upwardInfo); 
    return walkDownObjPathToGetType(type.c, aPrior.p);
  }else{
    return {t:'toDelete', msg:'Governing value is not valid as dynamic formula not applied'}
  }
}

export function countLists(p){
  return p.filter((aP, index)=>{
    return aP.t !== 'oP'
  }).length;
}

export function walkDownObjPathToGetType(init, p){ //path.
  if (!p){
    return init;
  }
  for (var i = 0; i < p.length; i++){
    var aCand = p[i];
    if (aCand.t === 'l'){
      if (init.c){
        init = init.c; 
      }else{
        return {t:'toDelete', msg:'Item is no longer a list'}
      }
    }else if (aCand.t === 'oP'){
      var title = aCand.n;
      var children = init.c;
      if (children){
        var haveFound = false;
        for (var j = 0; j < children.length; j++){
          if (children[j].n === title){
            init = children[j].t;
            haveFound = true;
            break;
          }
        }
        if (!haveFound){
          if (aCand.ti){
            console.warn(init);
            console.warn(aCand);
          }
          return {t:'toDelete', msg:'Object pointer no longer exists'}
        }
      }else{
        return {t:'toDelete'}
      }
    }else{
      if (init.c){
        init = init.c;
      }else{
        return {t:'toDelete'}
      }
      // console.log(aCand);
    }
  }
  return init;

}